// extracted by mini-css-extract-plugin
export default {"tabMenuList":"TabCoupon_tabMenuList__Y4SPy","tabMenuItem":"TabCoupon_tabMenuItem__gEOT2","active":"TabCoupon_active__UypUm"};